import { type FC, useCallback } from 'react';

import { ChipsOption } from 'shared/models/ChipsOption';
import { SliderBlockTypeOneSlideService } from 'shared/services/ChipsDataService';

import { SliderBlockTypeOne } from './SliderBlockTypeOne';
import { type ISliderBlockTypeOneModel, SliderBlockTypeOneModel } from './external/models/SliderBlockTypeOneModel';
import { SliderBlockTypeOneSlideModel } from './internal/models/SliderBlockTypeOneSlideModel';
import { trackShowEnvironmentLifeBusinessSection } from './internal/tracking/trackShowEnvironmentLifeBusinessSection';
import { trackSliderBlockTypeOneChipSelect } from './internal/tracking/trackSliderBlockTypeOneChipSelect';

const sliderBlockTypeOneSlideService = new SliderBlockTypeOneSlideService([
  new SliderBlockTypeOneModel(new ChipsOption('Благоустройство'), [
    new SliderBlockTypeOneSlideModel(
      'Дворы-парки',
      'Дворы-парки разрабатываются при участии профессиональных дизайнеров и дендрологов. В оформлении мы используем натуральные материалы и растения, устойчивые к городской среде.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/improvement/yards-parks.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Пространства для игр и отдыха',
      'Мы создаём тематические пространства с уникальным дизайном для жителей всех возрастов: PlayHub — современные и безопасные площадки, MultiHub — мультифункциональные пространства с продуманным зонированием',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/improvement/space-for-games.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Места для спорта',
      'SportHub — современные пространства для занятий спортом с продуманным зонированием, которые идеально подходят для любителей активного отдыха',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/improvement/places-for-sports.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Пешеходные бульвары',
      'Пешеходный бульвар — центральный элемент кварталов ПИК. Здесь находятся зоны для прогулок, велодорожки и озеленение. Продуманное зонирование создаёт комфортную среду без машин для жизни и общения.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/improvement/pedestrian-boulevards.jpg',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Инфраструктура'), [
    new SliderBlockTypeOneSlideModel(
      'Школы будущего',
      'В наших кварталах мы создаём все условия для развития детей. В школах действуют инновационные программы обучения и современные пространства для творчества и спорта.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/infrastructure/schools-of-the-future.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Детские сады',
      'Пространства, где создана гармоничная среда для раскрытия потенциала ребёнка: современные программы, продуманное зонирование и места для творчества',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/infrastructure/kindergartens.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Поликлиники',
      'Поликлиники с современным оборудованием и продуманной навигацией всегда находятся рядом с домом. Здоровье жителей — один из приоритетов при строительстве новых проектов.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/infrastructure/polyclinics.jpg',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Коммерческая недвижимость'), [
    new SliderBlockTypeOneSlideModel(
      'Коммерческие помещения',
      'В каждом квартале мы создаём комфортную среду для развития бизнеса: наши помещения подойдут для кафе, магазинов или других полезных сервисов',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/commercial-real-estate/commercial-premises.jpg',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Культура'), [
    new SliderBlockTypeOneSlideModel(
      'Сохранение культурного наследия',
      'ПИК восстанавливает памятники культуры, бережно сохраняя связь с историей. Старые здания обретают новую жизнь благодаря сочетанию традиционных технологий и инноваций.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/preservation-of-cultural-heritage.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Новая жизнь памятников культуры',
      'Исторические здания обретают полезные функции для жителей. Обновлённые объекты гармонично встраиваются в городскую среду, становятся местами для отдыха, музеями, картинными галереями и школами.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/new-life-for-cultural-monuments.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Школа «Лермонтовский 54»',
      'Объект культурного наследия, где в XIX веке располагалось старейшее в России кавалерийское училище. Мы бережно отреставрировали историческое пространство, наполнив его современными образовательными технологиями.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/school-Lermontovsky-54.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Образовательный центр в «Кантемировская 11»',
      'Памятник архитектуры начала XX века преобразился в современное образовательное пространство с VR-лабораториями, интерактивными классами',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/educational-center-in-Kantemirovskaya-11.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Водонапорная башня в «Яуза парк»',
      'Отреставрированная башня XIX века с аутентичными фасадами и стальными конструкциями станет частью общественного пространства в «Яуза парке»',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/water-tower-in-Yauza-Park.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Культурное наследие в Бурятии',
      'ПИК реставрирует 13 исторических деревянных домов в Улан-Удэ, соединяя историческое наследие Бурятии с жизнью современного города',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/environment-for-life-and-business/culture/cultural-heritage-of-buryatia.jpg',
    ),
  ]),
]);

const ID = 'environment-for-life-and-business';
const TITLE = 'Для жизни и бизнеса';
const DESCRIPTION =
  'Продуманное благоустройство, современная инфраструктура, пространства для бизнеса и сохранение культурного наследия';

/**
 * @description Контейнер для блока "Среда для жизни и бизнеса".
 */
export const EnvironmentForLifeAndBusinessContainer: FC = () => {
  const handleShow = useCallback(() => trackShowEnvironmentLifeBusinessSection(sliderBlockTypeOneSlideService, ID), []);

  const handleChipSelect = useCallback(
    (sliderBlockTypeOneModel: ISliderBlockTypeOneModel) =>
      trackSliderBlockTypeOneChipSelect(TITLE, ID, sliderBlockTypeOneModel),
    [],
  );

  return (
    <SliderBlockTypeOne
      description={DESCRIPTION}
      id={ID}
      sliderBlockTypeOneSlideService={sliderBlockTypeOneSlideService}
      title={TITLE}
      onChipSelect={handleChipSelect}
      onShow={handleShow}
    />
  );
};
